import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { AppShell } from './components/layout/AppShell';
import { DashboardPage } from './pages/DashboardPage';
import { InventoryPage } from './pages/InventoryPage';
import { OutshipmentPage } from './pages/OutshipmentPage';
import { TransferPage } from './pages/TransferPage';
import { NewAccountPage } from './pages/NewAccountPage';
import { AddressBookPage } from './pages/AddressBookPage';
import { ProductCatalogPage } from './pages/ProductCatalogPage';
import { AccountsPage } from './pages/AccountsPage';
import { AuditLogPage } from './pages/AuditLogPage';
import { SFTPMonitorPage } from './pages/SFTPMonitorPage';
import { ExportsPage } from './pages/ExportsPage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppShell>
          <Routes>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/inventory" element={<InventoryPage />} />
            <Route path="/outshipments/*" element={<OutshipmentPage />} />
            <Route path="/transfers/*" element={<TransferPage />} />
            <Route path="/new-accounts/*" element={<NewAccountPage />} />
            <Route path="/addresses" element={<AddressBookPage />} />
            <Route path="/products" element={<ProductCatalogPage />} />
            <Route path="/accounts" element={<AccountsPage />} />
            <Route path="/audit" element={<AuditLogPage />} />
            <Route path="/sftp" element={<SFTPMonitorPage />} />
            <Route path="/exports" element={<ExportsPage />} />
          </Routes>
        </AppShell>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </QueryClientProvider>
  );
}
